import React from 'react'
import { NavItem, NavLink } from 'reactstrap'
import { Menu } from 'react-feather'

// ** Utils
import { isUserLoggedIn } from '@utils'

const NavBarMobileMenu = (props) => {
  const { setMenuVisibility, ...rest } = props

  return (
    <ul {...rest}>

      {!!isUserLoggedIn() && (
        <NavItem className="mobile-menu mr-auto">
          <NavLink
            className="nav-menu-main menu-toggle hidden-xs is-active"
            onClick={() => setMenuVisibility(true)}
          >
            <Menu className="ficon" />
          </NavLink>
        </NavItem>
      )}
    </ul>
  )
}

export default NavBarMobileMenu
